<template>
  <section class="p-2">
    <v-card-title class="d-flex justify-space-between p-0 m-0">
      <div class="ps-2 headingFontsize">User Summary</div>
      <div>
        <bread-crumb :bread-crumbs="['User Summary']" />
      </div>
    </v-card-title>
    <v-data-table fixed-header  height="55vh"
      :headers="headers"
      :items="partnerUser"
      :search="search"
      item-key="name"
    >
      <template v-slot:item.first_name="{ item }">
        {{ item.first_name ? item.first_name : ""
        }}{{ item.middle_name ? item.middle_name : "" }}
        {{ item.last_name ? item.last_name : "" }}
      </template>
      <template v-slot:item.password_link="{ item }">
        <p class="custom-transform-class" v-if="item.is_active">
          <a @click="getadminPassLink(item)" class="border-b mt-5">RESEND</a>
        </p>
        <a v-else @click="getadminPassLink(item)" class="border-b mt-2">
          SEND
        </a>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-icon small color="success" class="mr-2" @click="editItem(item)">
            mdi-content-save-edit-outline
          </v-icon>
          <v-icon small color="primary" class="mr-2" @click="deleteItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </div>
      </template>

      <template v-slot:top>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
        <v-col class="mt-5">
          <v-row>
            <v-col class="mt-1">
              <v-btn
                depressed
                small
                class="text-capitalize me-3 text-decoration-none"
                color="primary"
                @click="
                  $router.push({
                    name: 'User Setup',
                    query: {
                      partner_code: partner_code,
                      partner_id: partner_id,
                      branch_id: branch_id,
                    },
                  })
                "
                >Create User</v-btn
              >
              <v-btn depressed @click="downloadExcelsheet" color="primary" small
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-col></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                hide-details
                class="me-4 mb-2"
                dense
                clearable
              ></v-text-field
            ></v-col>
          </v-row>
        </v-col>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="dialogDelete" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete this prameter?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            color="primary"
            outlined
            @click="deleteItemConfirm"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed small color="primary" outlined @click="closeDelete"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  name: "User Summary",
  mixins: [alerts],
  data() {
    return {
      loader: false,
      search: "",
      partner_code: null,
      parent_partner_id: null,
      branch_id: null,
      dialogDelete: false,
      partnerUser: [],
      passswordlink: [],
      headers: [
        { text: "Partner code", value: "partner_code" },
        { text: "Name", value: "first_name" },
        { text: "Contact No", value: "mobile" },
        { text: "Email", value: "email" },
        { text: "Country", value: "country" },
        { text: "Password Link", value: "password_link" },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },
  components: {
    Loading,
    BreadCrumb,
  },
  mounted() {
    this.partner_code = this.$route.query.partner_code;
    this.partner_id = this.$route.query.partner_id;
    this.branch_id = this.$route.query.branch_id;
    console.log(this.partner_code);
    this.getAllPartnerUsers();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.partnerUser) {
        this.exportToExcel(
          this.headers,
          this.partnerUser,
          "partner user Summary"
        );
      }
    },

    async getadminPassLink(code) {
      this.loader = true;
      try {
        const response = await partnerService.getPasswordLink(code.login_id);
        if (response.data.status_code === 200) {
          this.passswordlink = response.data;
          this.showAlertSuccess(response.data.message);
          console.log("passswordlink", this.passswordlink);
          this.stoploader();
        } else {
          this.passswordlink == [];
          this.showAlertError("Something went wrong please try again later.");
          this.stoploader();
        }
      } catch (error) {
        this.passswordlink = [];
        this.stoploader();
        console.error(error);
      }
    },

    async getAllPartnerUsers() {
      this.loader = true;
      try {
        const responseData = await partnerService.getAllPartnerUsers(
          this.partner_code
        );
        if (responseData.data.status_code == 200) {
          this.partnerUser = responseData.data.data;
          this.stoploader();
        } else {
          this.showAlertError("Failed" + responseData.data.message);
          this.loader = false;
        }
        console.log("user summary", responseData);
      } catch (e) {
        console.log(e);
        this.showAlertError("Fetch data Failed : Something went wrong");
        this.loader = false;
      }
    },
    editItem(item) {
      console.log(item);
      setTimeout(() => {
        this.$router.push({
          name: "User Setup",
          query: { partner_code: this.partner_code, id: item.partner_user_id },
        });
      }, 300);
    },
    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.partner_user_id;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deleteId = "";
      });
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await partnerService.deletePartnerUser(
          this.deleteId
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllPartnerUsers();
          this.stoploader();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loader = false;
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
        this.loader = false;
      }

      this.closeDelete();
    },
  },
};
</script>
